import type { RequestConfig } from '@customTypes/index';
import type { WorkInviteItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type UpdateWorkInviteParams = RequestConfig<
  Pick<WorkInviteItemDto, 'workInviteId'> &
    Partial<Omit<WorkInviteItemDto, 'workInviteId'>>
>;

export const updateWorkInvite = async ({
  params,
  config
}: UpdateWorkInviteParams) =>
  api.put<WorkInviteItemDto>(`/api/work/invites`, params, config);
